import { AchievementType, achievementTypeFromString } from './Achievement';

export interface UserAchievement {
  id: string;
  awardedOn: string[];
  type: AchievementType;
  isRepeatable: boolean;
  title: string;
  subtitle: string;
  position: number;
  obtainedAt: Date[];
  obtainedAtLocal: string[];
}

export function userAchievementFromJson(json: Record<string, unknown>): UserAchievement {
  return {
    id: json['id'] as string,
    awardedOn: ((json['awardedOn'] as unknown[]) ?? []).map((e) => e as string),
    type: achievementTypeFromString(json['type'] as string),
    isRepeatable: json['isRepeatable'] as boolean,
    title: json['title'] as string,
    subtitle: json['subtitle'] as string,
    position: (json['position'] as number | null) ?? 0,
    // Firestore Timestamps are converted to Date by firestoreParsers before reaching here
    obtainedAt: ((json['obtainedAt'] as unknown[]) ?? []).map((e) => e as Date),
    obtainedAtLocal: ((json['obtainedAtLocal'] as unknown[]) ?? []).map((e) => e as string),
  };
}

export function lastObtainedAtLocal(ua: UserAchievement): string | null {
  return ua.obtainedAtLocal.length > 0 ? ua.obtainedAtLocal[ua.obtainedAtLocal.length - 1] : null;
}

export function lastObtainedAt(ua: UserAchievement): Date | null {
  return ua.obtainedAt.length > 0 ? ua.obtainedAt[ua.obtainedAt.length - 1] : null;
}
